module.exports = __webpack_public_path__ + "img/ht.3ffb8e73.svg";